import ProductDescription from './ProductDescription'

const WGCornmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '017',
  IsBroadband: true,
  Texture: '',
  Color: '',
  Size: '',
  WholeGrainCert: false,
}

export default WGCornmealProduct
